"use strict";

var _lodash = require("lodash");
var _underscore = require("underscore");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var PRODUCT_HISTORY_PAGE_LIMIT = 5;
var EVENT_DATA_PRODUCTS_ERROR = 'Error getting information about workspace products';
var PRODUCT_TRANSACTIONS_ERROR = 'Error getting information about transactions for this product';
var SETTLEMENT_TRANSACTION_SUCCESSFUL = 'Transaction successful';
var SETTLEMENT_TRANSACTION_ERROR = 'Transaction failed';
var settleModalOptions = {
  title: '',
  saveLabel: 'Proceed',
  hasCancelButton: true,
  cancelLabel: 'Cancel',
  fields: {
    seatCount: {
      label: 'Number of seats',
      kind: 'number',
      default: 0,
      validations: {
        required: true,
        min: 1
      }
    },
    comment: {
      label: 'Comment',
      kind: 'text'
    }
  }
};
var OrgPerEventEntitlements = /*#__PURE__*/function () {
  OrgPerEventEntitlements.$inject = ["$rootScope", "$scope", "$location", "$q", "$window", "$timeout", "eventService", "userService", "entitlementsService", "modalService"];
  /* @ngInject */
  function OrgPerEventEntitlements($rootScope, $scope, $location, $q, $window, $timeout, eventService, userService, entitlementsService, modalService) {
    _classCallCheck(this, OrgPerEventEntitlements);
    this.$q = $q;
    this.$scope = $scope;
    this.$location = $location;
    this.$rootScope = $rootScope;
    this.$window = $window;
    this.$timeout = $timeout;
    this.eventService = eventService;
    this.entitlementsService = entitlementsService;
    this.modalService = modalService;
    this.userService = userService;
  }

  /**
   * Initializes data and adds event listener for next and previous page loading
   *
   */
  return _createClass(OrgPerEventEntitlements, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      this.userCanManageEntitlements = this.userService.matchesRoles({
        orgRole: 'entitlement_manager',
        orgId: this.organisation._id
      });
      this.userCanSettleOverUsage = this.userService.matchesRoles({
        globalRole: 'spotme_finance'
      });
      this.loading = true;
      var queryParams = this.$location.search();
      this.eventId = this.eventId || queryParams.eid;
      this.$q.all([this.entitlementsService.getOrganizationEventEntitlements(this.organisation._id, this.eventId).then(function (eventData) {
        return _this.eventData = eventData;
      }).catch(function (error) {
        console.error(error);
        _this.eventDataError = EVENT_DATA_PRODUCTS_ERROR;
      }), this.entitlementsService.getAvailableProducts(this.organisation._id).then(function (availableProducts) {
        return _this.availableProducts = availableProducts.reduce(function (accumulator, product) {
          accumulator[(product.name || '').toLowerCase()] = true;
          return accumulator;
        }, {});
      })]).finally(function () {
        return _this.loading = false;
      });
      this.$scope.$on('LOAD_PREVIOUS_TRANSACTION_PAGE', function (event, productName) {
        var _iterator = _createForOfIteratorHelper(_this.eventData.products),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var product = _step.value;
            if (product.name === productName) {
              var firstTransaction = (0, _underscore.first)(product.transactionsPage.items);
              _this.getOrganizationProductTransactions(product, {
                startAt: firstTransaction._id
              }).catch(function () {
                return _this.$rootScope.setFlashMessage(PRODUCT_TRANSACTIONS_ERROR, 'danger');
              });
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
      this.$scope.$on('LOAD_NEXT_TRANSACTION_PAGE', function (event, productName) {
        var _iterator2 = _createForOfIteratorHelper(_this.eventData.products),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var product = _step2.value;
            if (product.name === productName) {
              var lastTransaction = (0, _underscore.last)(product.transactionsPage.items);
              _this.getOrganizationProductTransactions(product, {
                endAt: lastTransaction._id
              }).catch(function () {
                return _this.$rootScope.setFlashMessage(PRODUCT_TRANSACTIONS_ERROR, 'danger');
              });
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      });
    }

    /**
     * Fetches the transactions history for a specific product for the current organization
     * for the current event, and assigns the transaction history to 'product.transactionsPage'.
     * Supports pagination
     *
     * @param {number} productIndex - The index of the product in the this.purchasedProducts array
     * @param {object} page - The object specifying the pagination
     */
  }, {
    key: "getOrganizationProductTransactions",
    value: function getOrganizationProductTransactions(product) {
      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        first: true
      };
      if (product.transactionsLoading) return;
      if (product.productCodes.length === 0) {
        product.transactionsPage = {
          hasNextPage: false,
          hasPreviousPage: false,
          items: []
        };
        return this.$q.resolve();
      }
      product.transactionsLoading = true;
      return this.entitlementsService.getOrganizationProductTransactions(this.organisation._id, product.productCodes, [this.entitlementsService.TYPE_EVENT, this.entitlementsService.TYPE_TRANSACTION, this.entitlementsService.TYPE_EXPIRED_EVENT, this.entitlementsService.TYPE_SETTLEMENT], this.eventId, Object.assign(page, {
        limit: PRODUCT_HISTORY_PAGE_LIMIT
      })).then(function (transactionsPage) {
        product.transactionsPage = transactionsPage;
        product.transactionsLoading = false;
      }).finally(function () {
        return product.transactionsLoading = false;
      });
    }

    /**
     * Expands/collapses the product transactions table. Fetches product transactions if missing
     *
     * @param {Event} event - The click event
     * @param {object} clickedProduct - The product that was clicked
     */
  }, {
    key: "onProductClick",
    value: function onProductClick(event, clickedProduct) {
      var _this2 = this;
      if (event) event.preventDefault();
      if (!clickedProduct.transactionsPage) {
        this.getOrganizationProductTransactions(clickedProduct).catch(function () {
          return _this2.productTransactionsError = PRODUCT_TRANSACTIONS_ERROR;
        });
      }
      this.eventData.products = this.eventData.products.map(function (product) {
        return Object.assign(product, {
          expanded: clickedProduct.name === product.name ? !product.expanded : false
        });
      });
    }

    /**
     * Backstage URL for given event id and event node url
     *
     * @param {String} eventId
     * @param {String} nodeUrl
     * @return {String}
     */
  }, {
    key: "getBackstageUrl",
    value: function getBackstageUrl(eventId, nodeUrl) {
      var eventNode = (nodeUrl || '').split('.')[0].replace('https://', '').replace('http://', '');
      return this.eventService.generateGeoOptimalEventUrl({
        node: eventNode,
        id: eventId || ''
      }, '', window.location.protocol);
    }

    /**
     * Opens the assign entitlement view
     *
     * @param {Object} product
     */
  }, {
    key: "addEntitlement",
    value: function addEntitlement(product) {
      if (!product || product.type === 'unmapped') return;
      this.$scope.$emit('CHANGE_TAB', {
        tab: 'assign-entitlement',
        params: {
          product: product.name,
          eid: this.eventId
        }
      });
    }

    /**
     * Check if a product can be added
     * @param {Object} product
     * @return {Boolean}
     */
  }, {
    key: "canBeAdded",
    value: function canBeAdded(product) {
      return this.userCanManageEntitlements && this.availableProducts && !!this.availableProducts[(product.name || '').toLowerCase()] && (product.multiple || !product.usage.available) && !product.usage.error;
    }

    /**
     * Settle over usage on given product
     * @param {Object} product
     * @return {Promise}
     */
  }, {
    key: "settleOverUsage",
    value: (function () {
      var _settleOverUsage = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(product) {
        var _this3 = this;
        var productType, modalOptions, _yield$this$modalServ, seatCount, comment;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              productType = product.type;
              modalOptions = (0, _lodash.cloneDeep)(settleModalOptions);
              if (productType === 'subscription') {
                modalOptions.formCanBeSaved = function (model) {
                  return Number.isInteger(model.seatCount);
                };
                modalOptions.message = "How many seats do you want to assign to ".concat(this.eventData.eventName, "?");
              } else {
                modalOptions.message = "Are you sure you want to assign ".concat(product.name, " to ").concat(this.eventData.eventName, "?");
                delete modalOptions.fields.seatCount;
              }
              _context.next = 5;
              return this.modalService.openModalWithForm(modalOptions);
            case 5:
              _yield$this$modalServ = _context.sent;
              seatCount = _yield$this$modalServ.seatCount;
              comment = _yield$this$modalServ.comment;
              _context.prev = 8;
              _context.next = 11;
              return this.entitlementsService.settleOverUsage(this.organisation._id, this.eventId, product, comment, seatCount);
            case 11:
              _context.next = 17;
              break;
            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](8);
              console.error(_context.t0);
              return _context.abrupt("return", this.$rootScope.setFlashMessage(SETTLEMENT_TRANSACTION_ERROR, 'danger'));
            case 17:
              this.$rootScope.setFlashMessage(SETTLEMENT_TRANSACTION_SUCCESSFUL);
              this.$timeout(function () {
                return _this3.$window.location.reload();
              }, 2000);
            case 19:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[8, 13]]);
      }));
      function settleOverUsage(_x) {
        return _settleOverUsage.apply(this, arguments);
      }
      return settleOverUsage;
    }())
  }]);
}();
module.exports = angular.module('backstage.components.orgs.view-org.entitlements-manager.org-per-event-entitlements', ['backstage.services']).component('bsOrgPerEventEntitlements', {
  templateUrl: '/src/angular/components/orgs/view-org/org-entitlements-manager/org-per-event-entitlements/org-per-event-entitlements.html',
  bindings: {
    organisation: '<',
    eventId: '@'
  },
  controllerAs: 'vm',
  controller: OrgPerEventEntitlements
}).name;